import React, { useContext, useEffect, useState, useRef } from "react";
import config from "../config.json";
import toast from "react-hot-toast";

const SocketContext = React.createContext();

export function useSocket() {
  return useContext(SocketContext);
}

export function SocketProvider({ id, children }) {
  const [socket, setSocket] = useState();
  const [reconnectAttempts, setReconnectAttempts] = useState(0);
  const reconnectTimeoutRef = useRef(null);

  useEffect(() => {
    const MAX_RECONNECT_ATTEMPTS = 5;

    const createWebSocket = () => {
      const newSocket = new WebSocket(
        `${config.websocketName}:${config.port}/ws/?id=${id}`
      );

      newSocket.onopen = () => {
        console.log("Connected");
        // toast.success("Web Socket Connected!", {
        //   duration: Infinity,
        //   id: "websocketSuccess",
        // });
        // toast.dismiss("websocketFail");
        // while (true) {
        //   setTimeout(() => {
        //     console.log("SENDING BYTE AS STAY OPEN COMMAND");
        //   }, 5000);
        // }
        // Reset the reconnect attempts count upon successful connection
        setReconnectAttempts(0);
      };

      newSocket.onclose = (event) => {
        console.log("WebSocket closed:", event);
        // toast.dismiss("websocketSuccess");
        // toast.error("Web Socket Closed!", {
        //   duration: Infinity,
        //   id: "websocketFail",
        // });

        if (reconnectAttempts < MAX_RECONNECT_ATTEMPTS) {
          // Try to reconnect after a delay (1 second)
          reconnectTimeoutRef.current = setTimeout(() => {
            setReconnectAttempts((prevAttempts) => prevAttempts + 1);
            createWebSocket();
          }, 10000);
        } else {
          console.error("WebSocket connection failed after 5 attempts.");
          // toast.error("Websocket couldnt be connected after multiple tries!", {
          //   duration: 5000,
          // });
          if (reconnectTimeoutRef.current) {
            clearTimeout(reconnectTimeoutRef.current);
          }
        }
      };

      setSocket(newSocket);
    };

    // Create the initial WebSocket connection
    createWebSocket();

    // Clean up the WebSocket and the reconnect timeout when the component unmounts
    return () => {
      if (reconnectTimeoutRef.current) {
        clearTimeout(reconnectTimeoutRef.current);
      }
      if (socket) {
        socket.close();
      }
    };
  }, [id]);

  return (
    <SocketContext.Provider value={socket}>{children}</SocketContext.Provider>
  );
}
